import * as React from "react"
import BeltPage from "../../components/belt-page"
import LightbulbFlash from "../../svgs/lightbulb-flash-solid.svg"
import WalmartLogo from "../../svgs/walmart-logo.svg"
import DedicatedSupport from "../../svgs/components/minimalist-pages/dedicated-support"
import HandsHelping from "../../svgs/hands-helping-solid.svg"
import UserTie from "../../svgs/user-tie-solid.svg"
import ClipboardList from "../../svgs/clipboard-list-solid.svg"
import WreckingBall from "../../svgs/wrecking-ball-solid.svg"
import DigitalCatalog from "../../svgs/components/minimalist-pages/digital-catalog-program"
import AdSensei from "../../svgs/components/minimalist-pages/ad-sensei"
import SearchSensei from "../../svgs/components/minimalist-pages/search-sensei"

const Services = ({location}) => (
    <BeltPage 
        location={location}
        bgColor={'bg-black'}
        color={'black'}
        hex={'#000000'}
        iconBackgroundColor={'icon-background-black'}
        blogCategory={'Strategy & Services'}
        bannerBtnColor={'btn-yellow'}
        bannerBtnContactUs={false}
        pillar={false}
        icon={<UserTie/>}
        title={'Managed Services (Black Belt)'}
        metaTitle={"Services"}
        metaDescription={"WhyteSpyder provides service solutions for all Walmart.com business needs, from managed search and ad campaign optimization to full-service catalog management."}
        subtitle={'MANAGED SOLUTIONS TO TAKE YOUR ITEMS TO THE NEXT LEVEL'}
        subheader={'Let our team of Walmart eCommerce experts and former Walmart merchants devise and execute strategies that remove barriers to success and accelerate your business on Walmart.com, saving untold time and resources on your end.'}
        tabsTitle={['EXPERT STRATEGY & HUMAN RESOURCES', <br/>, 'TO PUT YOUR ITEMS ON TOP']}
        tools={[
            {
                title: 'Search Sensei', 
                content: [
                    'Surgically optimize search and increase category sales for your top-performing items',
                    'Unlock category dominance by engaging our team of search experts and former Walmart merchants',
                    'Get your items to the top of search with Walmart-specific strategies and dedicated human resources'
                ],
                graphic: <SearchSensei className='w-80 tool-abstraction'/>,
                link: '/contact-us'
            },
            {
                title: 'Ad Sensei', 
                content: [
                    'Dedicated ad management services to optimize your ad budget while saving time and resources',
                    'Leverage powerful tools and strategies to advertise with impact and efficiency',
                    'Earn incremental sales via careful execution by our team of ad experts'
                ],
                graphic: <AdSensei className='w-80 tool-abstraction'/>,
                link: '/contact-us'
            },
            {
                title: 'Dedicated Support', 
                content: [
                    'Expert, dedicated human resources to manage your catalog of items on Walmart.com',
                    'Our team will spot opportunities, execute strategies, and track performance on your behalf',
                    'Specialized, scalable business model that saves time, resolves Walmart issues, and maximizes your investments'
                ],
                graphic: <DedicatedSupport className='w-80 tool-abstraction'/>,
                link: '/contact-us'
            },
            {
                title: 'Digital Catalog Program', 
                content: [
                    'Full-service catalog management by our team of Walmart experts and former Walmart merchants',
                    'An all-inclusive program to establish and manage digital catalog excellence on Walmart.com',
                    'Expert execution and detailed analytics, from item setup to search optimization'
                ],
                graphic: <DigitalCatalog className='w-80 tool-abstraction'/>,
                link: '/contact-us'
            }
        ]}
        benefits={{
            title: 'Benefits of our Services',
            cards: [
                {
                    icon: <WreckingBall/>,
                    title: 'Remove Barriers to Success',
                    body: 'Our team has years of experience solving the most common issues preventing items from succeeding on Walmart.com.'
                },
                {
                    icon: <UserTie/>,
                    title: 'Dedicated Human Resources',
                    body: 'Add our search engine experts and former Walmart merchants to your team to save time and broaden your capabilities.'
                },
                {
                    icon: <ClipboardList/>,
                    title: 'Full-Service Management',
                    body: 'Put our team of experts to work on your Walmart items, from setup to content to search and conversion.'
                },
                {
                    icon: <WalmartLogo/>,
                    title: 'Former Walmart Merchants',
                    body: 'Our service teams are made up of Walmart eCommerce experts with vast experience, including former Walmart category specialists and leading brand suppliers.'
                },
                {
                    icon: <LightbulbFlash/>,
                    title: 'Diagnostics & Solutions',
                    body: 'SKU Ninja can identify and resolve issues affecting your items that can drive immediate improvement within your category.'
                },
                {
                    icon: <HandsHelping/>,
                    title: 'SKU Ninja Support',
                    body: 'SKU Ninja subscribers have constant access to our expert customer success and technical support teams.'
                }
            ]
        }}
    />
)

export default Services